import React from 'react';
import {connect} from 'react-redux';
import {bindActionCreators} from "redux";
import _ from "lodash";


import {fetchUserFriends, resetUserFriends} from "../../../creators/user.friends";
import Aqp from "../../../libs/mk-react-aqp";


import Dropdown from "../../components/Dropdown";
import Icon from "../../components/Icon";
import Avatar from '../../components/Avatar';
import {LoadingBar} from "../../components/Loader";
import Toast from "../../components/Toast";
import RoomSendMessage from "./components/RoomSendMessage/RoomSendMessage";

class RoomCreate extends React.Component {
    constructor(props) {
        super(props);
        this.specialKey = ['Backspace', 'Tab', 'Delete', 'Home', 'End', 'ArrowLeft', 'ArrowRight', 'ArrowUp', 'ArrowDown', 'Enter', 'Meta', 'Shift', 'CapsLock', 'Control', 'Alt', 'Escape'];
        this.friendsFilter = {
            limit: 5,
            page: 1,
        };
        this.state = {
            toggleFriends: false,
            indexFriendList: 0,
            searchFriend: "",
            friendsList: _.get(this.props.location, "query.users") || [],
            mouseInPerimeter: false,
            isToogleToastNoFriend : true
        };
        this.aqp = new Aqp({"search": "utilisateur"}, {
            blacklist: ['limit', 'page'],
            // currentLink: this.props.match,
            filterDefault: this.friendsFilter
        });

        this.handleDeleteRoomUser = this.handleDeleteRoomUser.bind(this);
        this.addFriend = this.addFriend.bind(this);
        this.handleKeyPress = this.handleKeyPress.bind(this);
        this.handleSearchFriend = this.handleSearchFriend.bind(this);
        this.getUserFriends = _.debounce(this.getUserFriends, 300);

        document.addEventListener("keydown", this.handleKeyPress);
        this.getUserFriends();
    }

    componentWillUnmount() {
        document.removeEventListener("keydown", this.handleKeyPress);
        this.setState({toggleFriends: false, searchFriend: '', friendsList: []});
        this.props.resetUserFriends();
    }

    getUserFriends() {
        let query = this.aqp.set({...this.friendsFilter, search: this.state.searchFriend});
        this.props.fetchUserFriends(this.props.currentUserId, query);
    }

    handleSearchFriend(event) {
        this.setState({searchFriend: event.target.value, toggleFriends: true, isToogleToastNoFriend : false}, () => this.getUserFriends());
    }

    handleKeyPress({key}) {
        if (key === "Enter" && this.state.toggleFriends && this.props.userFriends.length >= 1) {
            let firstFriend = this.props.userFriends;

            let selectFriend = firstFriend[this.state.indexFriendList] || firstFriend[0];
            if (selectFriend) {
                this.addFriend(selectFriend);
            }

        }

        if (key === "ArrowDown" && this.state.toggleFriends) {
            let friends = this.props.userFriends;
            let count = friends.length - 1;

            let index = this.state.indexFriendList;
            index++;
            if (index > count) {
                index = 0;
            }
            this.handleIndexFriend(index);
        }
        if (key === "ArrowUp" && this.state.toggleFriends) {
            let friends = this.props.userFriends;
            let count = friends.length - 1;
            let index = this.state.indexFriendList;
            index--;
            if (index < 0) {
                index = count;
            }
            this.handleIndexFriend(index);
        }

        if (key === "Escape" && this.state.toggleFriends) {
            this.setState({searchFriend: "", toggleFriends: false, indexFriendList: 0});
        }
    }

    handleDeleteRoomUser(index) {
        let friendsList = this.state.friendsList;
        friendsList.splice(index, 1);
        this.setState({friendsList});
    }

    handleIndexFriend(index) {
        this.setState({indexFriendList: index});
    }

    handleMouseEnter(index) {
        this.setState({mouseInPerimeter: true, indexFriendList: index});
    }

    handleMouseLeave(index) {
        this.setState({mouseInPerimeter: false, indexFriendList: index});
    }

    addFriend(item) {
        let friendsList = this.state.friendsList;
        let checkFriendsList = friendsList.filter(filterItem => filterItem._id.toString() === item._id.toString());
        if (!checkFriendsList.length && friendsList.length < 10) {
            friendsList.push(item);
            this.setState({
                toggleFriends: false,
                searchFriend: '',
                friendsList
            }, () => this.getUserFriends());
        }
    }

    _handleBackButton() {
        this.props.history.goBack();
    }

    render() {
        return (
            <div className={"main-wrapper"}>
                <div className={`create-new-room-header ${this.state.friendsList.length === 10 ? 'list-is-full' : ''}`}>
                    {!!this.props.mobile && (
                        <div className={"responsive-btn"}
                             onClick={() => this._handleBackButton()}><Icon type={"arrow-left"}/>
                        </div>
                    )}
                    <input type={"text"}
                           placeholder={"TAPER ICI LE NOM D'UN OU PLUSIEURS AMI(E)S"}
                           value={this.state.searchFriend}
                           onChange={this.handleSearchFriend}
                           onFocus={() => this.setState({toggleFriends: true})}
                           onBlur={() => !this.state.mouseInPerimeter ? this.setState({toggleFriends: false}) : ""}
                    />
                    {this.props.userFriendsInitialized && this.props.userFriendsLoading && (
                        <LoadingBar/>
                    )}
                </div>
                {this.props.userFriendsInitialized && this.state.isToogleToastNoFriend && this.props.userFriendsTotal === 0 ? <Toast type={"info"} content={"Vous n'avez pas encore d'ami sur Voissa"} /> : null}
                <div className={"current-user-in-room"}>
                    <Dropdown className="tag-friend" align="right toggle-friend"
                              toggle={this.state.toggleFriends}>
                        {Array.isArray(this.props.userFriends) && this.props.userFriends.map((item, index) => (
                            <li
                                key={index}
                                onClick={() => this.addFriend(item)}
                                onMouseEnter={() => this.handleMouseEnter(index)}
                                onMouseLeave={() => this.handleMouseLeave(index)}
                                className={this.state.indexFriendList === index ? 'friends active' : ''}
                            >
                                <Avatar gender={item.profile.gender} avatar={item.profile.avatar}
                                        className="user-thumb" alt=""/> {item.username}
                            </li>
                        ))}
                    </Dropdown>
                    <div className={"row wrap selected-friends-listing"}>
                        {this.state.friendsList.map((item, index) => (
                            <div key={index} className="row align-center friends-container">
                                <div className="row align-center">
                                    <Avatar className="user-thumb" alt="" avatar={item.profile.avatar}
                                            gender={item.profile.gender}/> {item.username}
                                </div>
                                <span onClick={() => this.handleDeleteRoomUser(index)}><Icon
                                    type="close"/></span>
                            </div>
                        ))}
                    </div>
                </div>
                <div className="messenger-chat">
                    <div className="messages-list">
                        <div className="in-messages-list">
                        </div>
                    </div>
                </div>

                    <RoomSendMessage
                        isCreate={true}
                        currentRoom={""}
                        users={this.state.friendsList}
                        handleRoom={this.handleRoom}
                    />

            </div>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        userFriends: state.userFriends.data,
        userFriendsLoading: state.userFriends.loading,
        userFriendsInitialized: state.userFriends.initialized,
        userFriendsTotal: state.userFriends.total,
        currentUserId: state.currentUser.data && state.currentUser.data._id,
    }
};

const mapDispatchToProps = (dispatch) => bindActionCreators({
    fetchUserFriends,
    resetUserFriends,
}, dispatch);


export default connect(mapStateToProps, mapDispatchToProps)(RoomCreate);
